import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../app/hooks';
import { getStratigraphyLexicon, selectStratigraphy, updateStratigraphyLexicon } from '../../../services/stratigraphySlice';

import Container from './container';

const EditRole = ({}:any) => {    
    const { stratigraphyLexiconId } = useParams<any>();
    const dispatch = useAppDispatch();       

    useEffect(() => {
        dispatch(getStratigraphyLexicon({id: stratigraphyLexiconId}));
    }, [stratigraphyLexiconId]);
    
    let history = useHistory();

    const {  
        stratigraphyLexicon,
        loading,
        saving,
        error
      } = useSelector(selectStratigraphy); 

    const onUpdateStratigraphyLexicon = (stratigraphyLexicon: any) => {  
        stratigraphyLexicon.id = stratigraphyLexiconId;
        dispatch(updateStratigraphyLexicon(stratigraphyLexicon))        
        .unwrap()
        .then((response: any) => {
            toast.success("Successfully updated stratigraphy lexicon");
            history.push(`/admin/stratigraphy/lexicon/list`) ;
         })
      };

    return (
       <Container title="Edit Lexicon" 
                  stratigraphyLexicon={stratigraphyLexicon} 
                  loading={loading} 
                  saving={saving}
                  onSave={onUpdateStratigraphyLexicon}                  
                  error={{...error}}  /> 
    )    
};

export default EditRole;